import {createFileRoute} from '@tanstack/react-router'
import MatchEditView from "../../../marketplace/MatchEditView.tsx";

export const Route = createFileRoute('/_app/marketplace/edit/$game_uid')({
    component: RouteComponent,
})

function RouteComponent() {
    return <MatchEditView />
}
